import React, { FC } from "react"
import { useSelector } from "react-redux"

import { ReservedFields, ReservedSections } from "@/onboarding/features/product/models/Product"
import { getSectionChat, getSettings } from "@/onboarding/features/product/selectors"

import SectionHolder from "./shared/SectionHolder"
import Content from "./extra_fees/Content"
import Edit from "./extra_fees/Edit"

const ExtraFees: FC = () => {
  const sectionChat = useSelector(getSectionChat(ReservedFields.EXTRA_FEES))
  const { extra_fees } = useSelector(getSettings(ReservedFields.EXTRA_FEES))
  const isWriteable = extra_fees?.writeable ?? false
  const isChanged = extra_fees?.changed ?? false

  return (
    <SectionHolder
      title="Extra Fees"
      name={ReservedSections.EXTRA_FEES}
      editComponent={isWriteable ? Edit : null}
      editMethod="inline"
      importableFields={[ReservedFields.EXTRA_FEES]}
      showLockedIcon={!isWriteable}
      chat={sectionChat}
    >
      <Content changedComponent={isChanged} />
    </SectionHolder>
  )
}

export default ExtraFees
